import { DataSource } from "@angular/cdk/collections";
import { IApiCompany, IApiCompanyFilter, IApiCompanyOrderBy } from 'src/app/shared/modules/graphql/types/types';
import { NefcoPagedDataSource } from 'src/app/shared/helpers/nefco-data-source.class';
import { CompanyService } from './company.service';
import { ApiConnection } from '../../decorators/@ApiConnection.decorator';

export class CompanyDataSource extends NefcoPagedDataSource<IApiCompany, CompanyService> implements DataSource<IApiCompany> {
  @ApiConnection()
  public load(filters?: IApiCompanyFilter[]): Promise<any> {
    if (!this.listPage.orderBy) this.listPage.orderBy = IApiCompanyOrderBy.Name;
    return this.service.get(filters, this.listPage).toPromise();
  }
}
